import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="shared--go-back-button"
export default class extends Controller {
  onClickGoBack(event) {
    event.preventDefault();
    history.back();
  }
}
